export class UploadedFloorplan {
  constructor(
    public name: string,
    public fileUrl?: string,
    public description?: string,
    public tags?: string[],
  ) {}
}
